import { ReactElement, ReactNode } from 'react';
import './button-stack.css';

export interface ButtonStackProps {
  primaryAction: ReactNode;
  secondaryAction1?: ReactNode;
  secondaryAction2?: ReactNode;
  className?: string;
}

/**
 * ButtonStack provides a standardized way to stack buttons vertically.
 * Currently implements a common pattern with:
 * - One full-width primary action
 * - Two optional equal-width secondary actions
 *
 * The secondary actions are laid out in a grid to ensure equal widths
 * and proper spacing.
 */
export const ButtonStack = (props: ButtonStackProps): ReactElement => {
  const { primaryAction, secondaryAction1, secondaryAction2, className } =
    props;

  const hasSecondaryActions = secondaryAction1 || secondaryAction2;

  return (
    <div className={`button-stack ${className || ''}`}>
      <div className="primary-action">{primaryAction}</div>
      {hasSecondaryActions && (
        <div className="secondary-actions">
          {secondaryAction1 && (
            <div className="secondary-action">{secondaryAction1}</div>
          )}
          {secondaryAction2 && (
            <div className="secondary-action">{secondaryAction2}</div>
          )}
        </div>
      )}
    </div>
  );
};
